import { Pressable, StyleSheet } from "react-native";
import { ProductType } from "../../../../types/product";
import { MobileHomeProductProps } from "./MobileHomeProduct";
import { MobileProductCardContent } from "./MobileProductCardContent";

export type MobileProductCardProps = {
  productType: ProductType;
  type: "NORMAL" | "COMPACT";
  isNew?: boolean;
  disabled?: boolean;
};

export default function MobileProductCard(
  props: MobileProductCardProps & MobileHomeProductProps
) {
  const { productType, redirectProduct, disabled } = props;

  return (
    <Pressable
      style={styles.flex}
      onPress={() => redirectProduct(productType)}
      disabled={disabled}
    >
      <MobileProductCardContent {...props} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
});
